<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="" (click)="setcurrentpath(-1)">Home</a></li>
    <li class="breadcrumb-item" [class.active]="isLast==true" *ngFor="let item of fbs.currentpath; last as isLast; index as i">
      <a [routerLink]="" (click)="setcurrentpath(i)">{{item}}</a>
    </li>
  </ol>
</nav>
